import mimeDb from "mime-db";

import { INPUT_MAX_LENGTH } from "@/constants/Fields";

import { FILE_CUSTOM_MIME_TYPE_TO_EXTENSION } from "./file.constant";

/**
 * Converts file to base64.
 *
 * @param {File} file A file object.
 * @return Promise<unknown>
 */
export const convertFileToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const fileNameIsTooLong = (file: File) => {
  if (!file) return false;
  return file.name.length > INPUT_MAX_LENGTH;
};

export const getFileExtension = (file: File) => {
  const mimeType = file?.type?.toLowerCase().trim();

  if (!mimeType) return false;

  const customExt = FILE_CUSTOM_MIME_TYPE_TO_EXTENSION[mimeType];

  if (customExt) return customExt;

  return mimeDb[mimeType]?.extensions?.[0] ?? false;
};
